import { render, staticRenderFns } from "./slide1.vue?vue&type=template&id=9196a7d4&scoped=true&"
import script from "./slide1.vue?vue&type=script&lang=js&"
export * from "./slide1.vue?vue&type=script&lang=js&"
import style0 from "./slide1.vue?vue&type=style&index=0&id=9196a7d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9196a7d4",
  null
  
)

export default component.exports